import TreeNode from './TreeNode';
import TreeViewStyles from './TreeView.styles';

const TreeView = ({ t, postCodes, handleChangeLocation, isEditDisabled }) => (
  <TreeViewStyles.TreeWrapper>
    {postCodes.length > 0 && (
      <TreeViewStyles.TreeNodeHeader>
        {t('zones.addressList')}
      </TreeViewStyles.TreeNodeHeader>
    )}
    {postCodes?.map((postCode, postCodeIndex) => (
      // eslint-disable-next-line react/jsx-key -- FIXME
      <TreeNode
        label={postCode.code}
        onChange={value =>
          handleChangeLocation(draftState => {
            draftState[postCodeIndex].code = value;
          })
        }
        onDeleteNode={() =>
          handleChangeLocation(draftState => {
            draftState.splice(postCodeIndex, 1);
          })
        }
        isEditDisabled={isEditDisabled}
      >
        {postCode.cities?.map((city, cityIndex) => (
          // eslint-disable-next-line react/jsx-key -- FIXME
          <TreeNode
            label={city.name}
            indent={true}
            onChange={value =>
              handleChangeLocation(draftState => {
                draftState[postCodeIndex].cities[cityIndex].name = value;
              })
            }
            onDeleteNode={() =>
              handleChangeLocation(draftState => {
                draftState[postCodeIndex].cities.splice(cityIndex, 1);
              })
            }
            isEditDisabled={isEditDisabled}
          >
            {city.streets.length > 0 && (
              <TreeViewStyles.TreeNodeHeader indent={true}>
                {t('zones.streets')}
              </TreeViewStyles.TreeNodeHeader>
            )}
            {city.streets?.map((street, streetIndex) => (
              // eslint-disable-next-line react/jsx-key -- FIXME
              <TreeNode
                label={street.name}
                indent={true}
                onChange={value =>
                  handleChangeLocation(draftState => {
                    draftState[postCodeIndex].cities[cityIndex].streets[
                      streetIndex
                    ].name = value;
                  })
                }
                onDeleteNode={() =>
                  handleChangeLocation(draftState => {
                    draftState[postCodeIndex].cities[cityIndex].streets.splice(
                      streetIndex,
                      1
                    );
                  })
                }
                isEditDisabled={isEditDisabled}
              >
                {street.buildings.length > 0 && (
                  <TreeViewStyles.TreeNodeHeader indent={true}>
                    {t('zones.buildingNumbers')}
                  </TreeViewStyles.TreeNodeHeader>
                )}
                {street.buildings?.map(
                  (buildingNumber, buildingNumberIndex) => (
                    // eslint-disable-next-line react/jsx-key -- FIXME
                    <TreeNode
                      label={buildingNumber}
                      indent={true}
                      onChange={value =>
                        handleChangeLocation(draftState => {
                          draftState[postCodeIndex].cities[cityIndex].streets[
                            streetIndex
                          ].buildings[buildingNumberIndex] = value;
                        })
                      }
                      onDeleteNode={() =>
                        handleChangeLocation(draftState => {
                          draftState[postCodeIndex].cities[cityIndex].streets[
                            streetIndex
                          ].buildings.splice(buildingNumberIndex, 1);
                        })
                      }
                      isEditDisabled={isEditDisabled}
                    />
                  )
                )}
              </TreeNode>
            ))}
          </TreeNode>
        ))}
      </TreeNode>
    ))}
  </TreeViewStyles.TreeWrapper>
);

export default TreeView;
